var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"search--section",class:{
      'search--section--mobile' : _vm.isMobile,
      'search--section--desktop' : !_vm.isMobile,
    }},[_vm._m(0),_c('div',{staticClass:"search"},[_c('TemplateSearchV2')],1),_c('div',{staticClass:"categories",class:{
        'categories--mobile' : _vm.isMobile,
        'categories--desktop' : !_vm.isMobile,
      }},[_c('CategoryListV2')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("\n        Ready-made Presentation Templates\n      ")])])}]

export { render, staticRenderFns }